<template>
<div>

  <!-- Begin Title Bar -->
  <v-toolbar tile elevation="2">
    <v-toolbar-title>{{ $t('instantBuyTokenPage.title') }}</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn icon v-if="initializationDone" @click="$router.go(-1)">
      <v-icon class="color-green">mdi-arrow-left</v-icon>
    </v-btn>
    <v-btn icon v-if="initializationDone" @click="refresh">
      <v-icon class="color-green">mdi-refresh</v-icon>
    </v-btn>

  </v-toolbar>
  <!-- End Title Bar -->

  <v-container style="max-width: 600px;">
  <v-sheet elevation="2" class="pa-5 my-4">

    <Preloader v-show="!initializationDone" />

    <div v-if="initializationDone" class="main-content">

      <div v-if="!currentTokenInfo || !currentTokenInfo.name" class="content-box p-3 text-center shadow-box-light">
        {{ $t('instantBuyTokenPage.tokenNotFound') }}
       </div>

      <div v-else class="content-box shadow-box-light">

        <div class="section-title mt-3 mb-4 text-center">
          {{ $t('instantBuyTokenPage.title') }}:  {{currentTokenInfo.name}}
         ({{currentTokenInfo.symbol}})
        </div>

        <div class="mb-4 mx-3" v-html="$t('instantBuyTokenPage.introTxt')">
        </div>

        <div v-if="!tokenAvailableToBuy" class="text-center p-3 mx-3 mb-4 bg-gray">
          <strong>{{ $t('instantBuyTokenPage.tokenNotAvailableForBuying')}}</strong>
        </div>

        <div v-else class="text-center mb-4 px-4">
          <div class="bg-gray p-4 mb-4 text-left">
            <p>{{ $t('instantBuyTokenPage.pleaseVerifiyToken')}}</p>
            <strong>{{ $t('common.token.name') }}</strong>: {{ currentTokenInfo.name }}<br />
            <strong>{{ $t('common.token.symbol') }}</strong>: {{ currentTokenInfo.symbol }}<br />
            <strong>{{ $t('common.token.address') }}</strong>: <a :href="etherScanTokenURL + currentTokenInfo.address" style="text-decoration: underline;" target="_blank">{{ currentTokenInfo.address }}</a>
          </div>
          <v-btn large color="success" v-on:click="renderInstant()">{{ $t('instantBuyTokenPage.btnTxtBuy') }}  {{currentTokenInfo.symbol}}</v-btn>
        </div>

      </div>

    </div>

  </v-sheet>
</v-container>

  <div class="overlay">
    <div id="instant-buy-form" class="overlay-content"></div>
  </div>

</div>
</template>

<script>
import { config } from '@/config'
import { assetDataUtils} from '@0x/order-utils'
import {mapActions, mapGetters, mapState} from 'vuex'
import OrderSummary from "@/components/OrderSummary"
import BackButton from "@/components/BackButton"
import { searchTokenByAddress } from '@/utils/TokenUtils'
import { loadExternalScript } from '@/utils/utils'
import Preloader from "@/components/Preloader"
import { HttpClient } from '@0x/connect'
import { AssetProxyId } from '@0x/types'
import Vue from 'vue'

export default {
  name: 'InstantBuy',
  data () {
    return {
      config: config,
      tokenType: this.$route.params.tokenType,
      tokenAddress: this.$route.params.tokenAddress,
      orderSourceList: [],
      selectedOrderSource: null,
      tokenAvailableToBuy: false,
      currentTokenInfo: {},
      initializationDone: false,
    }
  },
  computed: {
    ...mapGetters({
      network: 'getNetwork',
      account: 'getAccount',
      tokenInfo: 'getTokenInfo',
      networkConfig: 'getNetworkConfig',
    }),
    etherScanTokenURL: function () {
      return this.config.network[this.network.id].tokenURL
    }
  },
  components: {
    Preloader,
    BackButton
  },
  methods: {
    ...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount', 'getTokenInfoByAddress']),

    /* ------------------------------------------------------ */
    async init () {
      this.initializationDone = false

      const scriptURL = this.config.zeroExInstantScriptURL
      await loadExternalScript(scriptURL)
      await this.loadNetwork()
      await this.loadTokenInfo()

      this.orderSourceList = this.networkConfig.relayers
      console.log(this.orderSourceList)

      if (this.tokenType.toLowerCase() === 'erc20') {
        await this.loadERC20Token()
        console.log(this.currentTokenInfo)
      }
      await this.checkTokenLiquidity()
      this.initializationDone = true
      // if (this.currentTokenInfo.name) {
      //   await this.renderInstant()
      // }
    },

    async renderInstant () {

      if (!this.currentTokenInfo.assetData || !this.selectedOrderSource.apiURL) {
        return
      }

      const assetData = this.currentTokenInfo.assetData
      // console.log(assetData)

      const assetMeta = {}
      assetMeta[assetData] = {
        assetProxyId: this.currentTokenInfo.assetProxyId,
        decimals: this.currentTokenInfo.decimals,
        symbol: this.currentTokenInfo.symbol,
        name: this.currentTokenInfo.name,
      }

      console.log(this.selectedOrderSource.apiURL)

      zeroExInstant.render(
        {
          networkId: this.network.id,
          orderSource: this.selectedOrderSource.apiURL,
          availableAssetDatas: [assetData],
          defaultSelectedAssetData: assetData,
          additionalAssetMetaDataMap: assetMeta
        }, '#instant-buy-form')

    },

    async checkTokenLiquidity () {

      if (!this.currentTokenInfo.name) {
        return
      }

      if (this.tokenType.toLowerCase() === 'erc20') {
        this.currentTokenInfo.assetData = assetDataUtils.encodeERC20AssetData(this.currentTokenInfo.address)
        this.currentTokenInfo.assetProxyId = AssetProxyId.ERC20
      }
      else if (this.tokenType.toLowerCase() === 'erc721') {
        this.currentTokenInfo.assetData = assetDataUtils.encodeERC721AssetData(this.currentTokenInfo.address)
        this.currentTokenInfo.assetProxyId = AssetProxyId.ERC721
      }
      else {
        console.log('unknown tokenType: ' + this.tokenType)
        return
      }

      // const assetData = this.currentTokenInfo.assetData

      // const assetData = zeroExInstant.assetDataForERC20TokenAddress(this.currentTokenInfo.address)

      const searchOptions = {
        baseAssetData: assetDataUtils.encodeERC20AssetData(this.currentTokenInfo.address),
        quoteAssetData: assetDataUtils.encodeERC20AssetData(this.tokenInfo.WETHToken.address)
      }

      const relayersWithLiquidity = []

      const tasks = []
      for (let relayer of this.orderSourceList) {

        try {
          const relayerApiURL = relayer.apiURL
          const httpClient = new HttpClient(relayerApiURL)
          const orderBook = await httpClient.getOrderbookAsync(
            searchOptions
          )
          // console.log(orderBook)
          console.log(relayer.name.charAt(0) + ': ' + orderBook.asks.total + ' asks, ' + orderBook.bids.total + ' bids' )
          if (orderBook.asks.total > 0) {
            this.selectedOrderSource = relayer
            this.tokenAvailableToBuy = true
            break
          }

        } catch (err) {
          console.log(relayer.name + ' Error: ' + err)
          // console.log(relayer.name + ' Error: ' + err.toString())
        }

      }

    },

    async checkTokenLiquidity_old () {

      if (!this.currentTokenInfo.name) {
        return
      }

      if (this.tokenType.toLowerCase() === 'erc20') {
        this.currentTokenInfo.assetData = assetDataUtils.encodeERC20AssetData(this.currentTokenInfo.address)
        this.currentTokenInfo.assetProxyId = AssetProxyId.ERC20
      }
      else if (this.tokenType.toLowerCase() === 'erc721') {
        this.currentTokenInfo.assetData = assetDataUtils.encodeERC721AssetData(this.currentTokenInfo.address)
        this.currentTokenInfo.assetProxyId = AssetProxyId.ERC721
      }
      else {
        console.log('unknown tokenType: ' + this.tokenType)
        return
      }

      // const assetData = this.currentTokenInfo.assetData

      const assetData = zeroExInstant.assetDataForERC20TokenAddress(this.currentTokenInfo.address)
      console.log(this.orderSourceList)

      for (let orderSource of this.orderSourceList) {
        let liquidity = null
        try {
          liquidity = await zeroExInstant.hasLiquidityForAssetDataAsync(assetData, orderSource.apiURL, this.network.id)
        } catch (err) {
          console.log(err)

          // this.selectedOrderSource = orderSource
          // this.tokenAvailableToBuy = true


        }
        console.log(orderSource.name + ': ' + liquidity)
        if (liquidity === true) {
          this.selectedOrderSource = orderSource
          this.tokenAvailableToBuy = true
          break
        }
      }

    },

    async loadERC20Token () {
      const tokenAddress = this.tokenAddress.toLowerCase()

      // First check local storage
      const localStorageKey = 'tokeninfo-' + this.network.id + '-' + tokenAddress
      const localStored = localStorage.getItem(localStorageKey)
      if (localStored) {
        const tokenInfo = JSON.parse(localStored)
        // console.log('got tokenInfo from local storage: ', tokenInfo)
        this.currentTokenInfo = tokenInfo
        return
      }

      // Load token info from the blockchain with the standard ABI
      // console.log('trying standardABISearch')
      const tokenStandardABISearch = await searchTokenByAddress(tokenAddress)
      if (tokenStandardABISearch) {
        localStorage.setItem(localStorageKey, JSON.stringify(tokenStandardABISearch))
        // console.log('got tokenInfo from standardABISearch')
        this.currentTokenInfo = tokenStandardABISearch
        // console.log(this.currentTokenInfo)
        return
      }

      // Load token from the blockchain with their own ABI
      const etherscanApiURL = this.config.network[this.network.id].etherscanApiURL
        + 'api?module=contract&action=getabi&address=' + tokenAddress + ''
      // console.log('try etherscanApiURL', etherscanApiURL)
      const etherscanRes = await Vue.http.get(etherscanApiURL)
      // console.log(etherscanRes)
      if (etherscanRes && etherscanRes.body && etherscanRes.body.result) {
        let tokenABI = null
        try {
          tokenABI = JSON.parse(etherscanRes.body.result)
        } catch (err) {
          console.log(err)
        }
        if (tokenABI) {
          const tokenABISearch = await searchTokenByAddress(tokenAddress, tokenABI)
          if (tokenABISearch) {
            localStorage.setItem(localStorageKey, JSON.stringify(tokenABISearch))
            this.currentTokenInfo = tokenABISearch
            // console.log(this.currentTokenInfo)
            return
          }
        }
      }

      return
    },

    async refresh () {
      this.selectedOrderSource = null
      this.tokenAvailableToBuy = false
      this.currentTokenInfo = {}
      this.initializationDone = false
      this.init();
    },

  },
  created () {
    // this.$emit('hide-sidebar')
    this.init()
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 999999999999 !important;
  top: 0;
  left: 0;
}
.overlay-content {
  position: relative;
}
.main-content a,
.main-content p a,
.main-content .fa {
  color: #26A65B !important;
}
</style>
